import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M23.695 21.896c1.225.097 2.884.245 3.809.49.033.204.032.342.002.468-.032.133-.108.295-.29.527l-2.635-.182-.886-1.303zm-.072-1.008a.929.929 0 0 0-.84 1.447l.992 1.457a.924.924 0 0 0 .699.402l2.72.188c.28.02.572-.09.765-.328.263-.324.438-.632.519-.966.08-.336.054-.65-.004-.959a.88.88 0 0 0-.624-.685c-1.063-.3-3-.46-4.227-.556zM5.837 8.292a1.902 1.902 0 0 1 2.59.723l6.955 12.332a.845.845 0 0 1-.32 1.152l-1.841 1.038a.845.845 0 0 1-1.152-.321L5.115 10.883a1.902 1.902 0 0 1 .722-2.59zm7.027 14.298L5.986 10.392a.902.902 0 1 1 1.57-.886l6.88 12.198-1.572.886z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.204 11.832c-1.145-.705-2.276-.84-3.478-.722l.098.995c1.049-.103 1.945.018 2.855.579.93.574 1.922 1.637 3.083 3.522l.851-.525c-1.195-1.94-2.285-3.156-3.409-3.848z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.323 16.909c1.824.345 3.442 1.01 4.437 2.148 1.57 1.796 1.48 3.967 1.192 5.336-.049.229-.286.47-.715.47h-9.642a1 1 0 0 1-1-1v-6.339c0-.509.36-.863.775-.885 1.297-.07 3.152-.07 4.953.27zm-5.007-1.269c2.675-.144 7.774-.012 10.197 2.759 1.873 2.142 1.732 4.702 1.417 6.2-.164.784-.892 1.265-1.693 1.265h-9.642a2 2 0 0 1-2-2v-6.34c0-.993.73-1.83 1.721-1.884z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 11.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z",
      fill: "currentColor"
    })]
  }));
};
export default SvgComponent;